/******/ (() => { // webpackBootstrap
class animatedBackgroundTextColors extends HTMLElement {
  constructor() {
    super();

    this.blocks = this.querySelectorAll('[data-announcement-block]');
    this.index = 1;
    this.interval = null;
    this.prevBtn = null;
    this.nextBtn = null;
    this.onPrevClick = this.handlePrevClick.bind(this);
    this.onNextClick = this.handleNextClick.bind(this);
  }

  pacificTodayYMD() {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles' }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  pacificNowYMDHM() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var get = function(type) {
        var part = parts.find(function(p) { return p.type === type; });
        return part ? part.value : '';
      };
      return get('year') + '-' + get('month') + '-' + get('day') + ' ' + get('hour') + ':' + get('minute');
    } catch (e) {
      var d = new Date();
      var pad = function(n) { return String(n).padStart(2, '0'); };
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    }
  }

  isBlockInSchedule(block) {
    var start = block.getAttribute('data-schedule-start');
    var end = block.getAttribute('data-schedule-end');
    if (!start && !end) return true;
    var today = this.pacificTodayYMD();
    var now = this.pacificNowYMDHM();
    if (start) {
      if (start.indexOf(' ') !== -1) {
        if (now < start) return false;
      } else if (today < start) {
        return false;
      }
    }
    if (end) {
      if (end.indexOf(' ') !== -1) {
        if (now > end) return false;
      } else if (today > end) {
        return false;
      }
    }
    return true;
  }

  applyScheduleFilter() {
    if (window.Shopify && window.Shopify.designMode) return;
    var removed = false;
    Array.prototype.slice.call(this.querySelectorAll('[data-announcement-block]')).forEach(function(block) {
      if (!this.isBlockInSchedule(block)) {
        block.remove();
        removed = true;
      }
    }.bind(this));
    if (!removed) return;

    var remaining = this.querySelectorAll('[data-announcement-block]');
    remaining.forEach(function(block, index) {
      block.setAttribute('data-announcement-block-index', String(index));
      block.classList.toggle('active', index === 0);
    });

    if (remaining.length && remaining[0]) {
      this.style.backgroundColor = remaining[0].getAttribute('data-background-color-block');
      this.style.color = remaining[0].getAttribute('data-front-color-block');
    }

    var bar = this.closest('.announcement_bar');
    if (!bar) return;
    if (remaining.length <= 1) {
      bar.classList.remove('announcement_bar--has-nav');
      var navBtns = bar.querySelectorAll('.announcement_bar__nav');
      navBtns.forEach(function(btn) { btn.style.display = 'none'; });
    }
  }

  connectedCallback() {
    this.applyScheduleFilter();
    this.blocks = this.querySelectorAll('[data-announcement-block]');
    if (this.blocks.length <= 1) return;

    const bar = this.closest('.announcement_bar');
    this.prevBtn = bar ? bar.querySelector('[data-announcement-prev]') : null;
    this.nextBtn = bar ? bar.querySelector('[data-announcement-next]') : null;

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrevClick);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNextClick);

    this.startAutoRotate();

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.handleBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect.bind(this));
    }
  }

  disconnectedCallback() {
    this.stopAutoRotate();
    if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrevClick);
    if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNextClick);
  }

  getActiveIndex() {
    for (let i = 0; i < this.blocks.length; i++) {
      if (this.blocks[i].classList.contains('active')) return i;
    }
    return 0;
  }

  goToBlock(blockIndex, options) {
    const opts = options || {};
    const activeBlock = this.blocks[blockIndex];
    if (!activeBlock) return;

    const backgroundColor = activeBlock.getAttribute('data-background-color-block');
    const frontColor = activeBlock.getAttribute('data-front-color-block');

    if (opts.instant) {
      this.style.transition = 'none';
      this.style.backgroundColor = backgroundColor;
      this.style.color = frontColor;
      requestAnimationFrame(() => {
        this.style.transition = '';
      });
    } else {
      setTimeout(() => {
        this.style.backgroundColor = backgroundColor;
        this.style.color = frontColor;
      }, 350);
    }

    const prevActiveBlock = this.querySelector('[data-announcement-block].active');
    if (prevActiveBlock) prevActiveBlock.classList.remove('active');
    activeBlock.classList.add('active');

    this.index = (blockIndex + 1) % this.blocks.length;
  }

  changeColors() {
    this.goToBlock(this.index);
  }

  handlePrevClick() {
    const current = this.getActiveIndex();
    const prevIndex = (current - 1 + this.blocks.length) % this.blocks.length;
    this.goToBlock(prevIndex);
    this.startAutoRotate();
  }

  handleNextClick() {
    this.goToBlock(this.index);
    this.startAutoRotate();
  }

  startAutoRotate() {
    this.stopAutoRotate();
    this.interval = setInterval(this.changeColors.bind(this), 7000);
  }

  stopAutoRotate() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  handleBlockSelect(e) {
    const blockIndex = e.target.dataset.announcementBlockIndex;
    if (blockIndex === undefined) return;

    this.blocks.forEach(block => block.classList.remove('active'));
    e.target.classList.add('active');

    this.goToBlock(parseInt(blockIndex, 10), { instant: true });
    this.stopAutoRotate();
  }

  handleBlockDeselect(e) {
    const blockIndex = e.target.dataset.announcementBlockIndex;
    if (blockIndex === undefined) return;

    this.index = (parseInt(blockIndex, 10) + 1) % this.blocks.length;
    this.startAutoRotate();
  }
}

customElements.define('animated-background-text-colors', animatedBackgroundTextColors);

/******/ })()
;
